import { Table, TableBody, TableCell, TableContainer, TableRow, Card } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzNursePrintButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNurseOkeyButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseOkeyButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseAddButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseAddButton";

export default function NurseButtons() {
  return (
    <Card sx={{ mb: 3 }}>
      <ByzMuiTypography variant="h3" sx={{borderBottom: "1px solid #E0E0E0"}}>Hemşire Butonları</ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "50%",}}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <ByzNurseAddButton onClick={() => alert("Add Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNurseAddButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzNurseDeleteButton onClick={() => alert("Delete Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNurseDeleteButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzNurseOkeyButton onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNurseOkeyButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzNursePrintButton onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNursePrintButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzNursePrintButton2 onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNursePrintButton2</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzNurseSaveButton onClick={() => alert("edit Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzNurseSaveButton</ByzMuiTypography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};